import { render, staticRenderFns } from "./TriggerSummary.vue?vue&type=template&id=f9488b50&"
import script from "./TriggerSummary.vue?vue&type=script&lang=ts&"
export * from "./TriggerSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports